export enum QuestionType {
  Initial = 'Initial',
  Regular = 'Regular',
}
